export default class Point {
	readonly x:number;
	readonly y:number;

	constructor(x:number, y:number){
		this.x = x;
		this.y = y;
	}

	public add = (b:Point):Point => {
		return new Point(this.x + b.x, this.y + b.y);
	}

	public sub = (b:Point):Point => {
		return new Point(this.x - b.x, this.y - b.y);
	}

	public rotate = (origin:Point, angle:number):Point => {
		//Convert angle to radians
		angle = angle * Math.PI / 180;

		//Difference between point and origin
		let dx = this.x - origin.x;
		let dy = this.y - origin.y;

		//Calculate difference after rotation
		let new_dx = dx * Math.cos(angle) - dy * Math.sin(angle);
		let new_dy = dx * Math.sin(angle) + dy * Math.cos(angle);

		return new Point(new_dx + origin.x, new_dy + origin.y);
	}
}